import { z } from 'zod';

export const KNOWN_SECTIONS = [
  'documents',
  'news',
  'notebook',
  'macro',
  'chat',
  'agenda',
  'latest-documents',
  'document-preview',
  'ai-summary',
  'analyze',
] as const;

export type KnownSectionSlug = (typeof KNOWN_SECTIONS)[number];

export const TOP_LEVEL_SECTION_SLUGS = ['documents', 'news', 'notebook', 'macro', 'chat'] as const;
export type TopLevelSectionSlug = (typeof TOP_LEVEL_SECTION_SLUGS)[number];

export const DOCUMENT_SECTION_SLUGS = ['document-preview', 'ai-summary', 'analyze'] as const;
export type DocumentSectionSlug = (typeof DOCUMENT_SECTION_SLUGS)[number];

export const SECTION_NAMES: Record<KnownSectionSlug, string> = {
  documents: 'Документы',
  news: 'Новости',
  notebook: 'Блокнот',
  macro: 'Макро',
  chat: 'Чат',
  agenda: 'Повестка',
  'latest-documents': 'Последние документы',
  'document-preview': 'Исходный документ',
  'ai-summary': 'ИИ-саммари',
  analyze: 'Анализ',
};

export const organizationSectionsResponseSchema = z.object({
  sections: z.array(z.unknown()).default([]),
});

export const organizationSectionItemSchema = z.object({
  slug: z.string(),
  name: z.string().optional().default(''),
  is_enabled: z.boolean().optional().default(true),
  show_model_selection: z.boolean().nullable().optional(),
});

export type OrganizationSectionItemApi = z.infer<typeof organizationSectionItemSchema>;
export type OrganizationSectionsResponseApi = z.infer<typeof organizationSectionsResponseSchema>;

export type OrganizationSection = {
  slug: KnownSectionSlug;
  name: string;
  showModelSelection: boolean | null;
};

export const isKnownSectionSlug = (slug: string): slug is KnownSectionSlug => {
  return KNOWN_SECTIONS.includes(slug as KnownSectionSlug);
};

export const isTopLevelSectionSlug = (slug: KnownSectionSlug): slug is TopLevelSectionSlug => {
  return TOP_LEVEL_SECTION_SLUGS.includes(slug as TopLevelSectionSlug);
};

export const isDocumentSectionSlug = (slug: KnownSectionSlug): slug is DocumentSectionSlug => {
  return DOCUMENT_SECTION_SLUGS.includes(slug as DocumentSectionSlug);
};
